export default __webpack_public_path__ + "static/media/css.af5776cc.png";